import React from "react";

const FilterContainer = ({ children, className = "" }) => (
  <div className={`bg-gray-50 rounded-lg shadow-sm border border-gray-200 p-6 ${className}`}>
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 items-end">
      {children}
    </div>
  </div>
);

export default FilterContainer;
